import { render, staticRenderFns } from "./messageNotificationSetting.vue?vue&type=template&id=dc5c1226&"
import script from "./messageNotificationSetting.vue?vue&type=script&lang=js&"
export * from "./messageNotificationSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/home/ctrl/messageNotification/messageNotificationSetting.vue"
export default component.exports